export const LEGAL_NAME = 'Timeline Longevity';
export const BRAND_NAME = 'Timeline Longevity';
export const MANUFACTURER_NAME = 'Timeline Longevity';

export const LOGO_PATH = 'https://static.timeline.com/icons/json-ld-logo.png';

export const SUPPORT_EMAIL = 'care@timeline.com';
export const SUPPORT_PHONE = '+1-888-631-3359';
export const SUPPORT_PORTAL = 'https://help.timeline.com';

export interface SocialLink {
  name: 'instagram' | 'facebook' | 'youtube' | 'tiktok';
  label: string;
  href: string;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  {
    name: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/timeline_longevity',
  },
  {
    name: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/TimelineLongevity',
  },
  {
    name: 'youtube',
    label: 'YouTube',
    href: 'https://www.youtube.com/@timelinelongevity/videos',
  },
  {
    name: 'tiktok',
    label: 'Tiktok',
    href: 'https://www.tiktok.com/@timelinelongevity',
  },
];

export const SAME_AS: readonly string[] = SOCIAL_LINKS.map((p) => p.href);

export const CONTACT_POINT = {
  contactType: 'customer care',
  email: SUPPORT_EMAIL,
  telephone: SUPPORT_PHONE,
  url: SUPPORT_PORTAL,
} as const;

export const DEFAULT_MERCHANT_RETURN_POLICY = {
  returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
  merchantReturnDays: 30,
  returnMethod: 'https://schema.org/ReturnByMail',
  returnFees: 'https://schema.org/FreeReturn',
  refundType: 'https://schema.org/FullRefund',
} as const;
